import {
  Card,
  DisplayText,
  EmptyState,
  ESpacings,
  Grid,
} from "@rentiohq/web-shared/dist/components";
import { memo } from "react";
import * as t from "../../../../../services/translationService";

// This screen only renders for brokers with the Rentmatch feature, since the
// router picks between the two containers on that flag, so nothing here has to
// test for it again. Of the six blocks below, only this one names the product,
// so only this one has a Rentmatch wording (DEV-3065).
const BRANDED_BLOCK_INDEX = 3;

const PropertyDetailApplicationEmptyState = () => {
  return (
    <Grid spacing="loose">
      <Grid.Item width={1}>
        <Card hasSections>
          <EmptyState
            size="large"
            backgroundColor="white"
            heading={t.applicationsOverviewEmptyStateTitleRentmatch()}
          >
            <p>{t.applicationsOverviewEmptyStateContentRentmatch()}</p>
          </EmptyState>
        </Card>
      </Grid.Item>
      <Grid.Item width={1}>
        <Card>
          <Grid spacing="loose">
            {[...Array(6)].map((node, index) => (
              <Grid.Item
                width={[1, 1, 1 / 2]}
                key={index}
                mb={ESpacings.superLoose}
              >
                <DisplayText size="medium" element="h3">
                  {t.applicationsOverviewEmptyStateBlockTitle(index)}
                </DisplayText>
                <p>
                  {index === BRANDED_BLOCK_INDEX
                    ? t.applicationsOverviewEmptyStateBlockBodyRentmatch()
                    : t.applicationsOverviewEmptyStateBlockBody(index)}
                </p>
              </Grid.Item>
            ))}
          </Grid>
        </Card>
      </Grid.Item>
    </Grid>
  );
};

export const PropertyDetailApplicationEmptyStateMemo = memo(
  PropertyDetailApplicationEmptyState,
);
